
import React, { useState, useEffect, Suspense } from 'react';
import { Switch, Route, Redirect, Link, useLocation } from 'react-router-dom';
import { Notification } from '@eds/vanilla';
import BreadCrumbs from './components/BreadCrumbs';
import MissingPage from './pages/PageNotFound';
import Globalfilters from './components/GlobalContext';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import FieldsSelector from './components/GlobalReduxFilters/Widgets/FieldsSelector';
//import FilterList from './components/GlobalReduxFilters/FilterList';
import * as actionCreators from './components/GlobalReduxFilters/actionCreators';
// import Dashboard from './Dashboard';
import useGetDashboardListData from './hooks/useGetDashboardListData';
import { useDispatch } from 'react-redux';
import {
  resetFilters,
  resetTime
} from './components/GlobalContext/GlobalfiltersData';
import { setSearchText } from '../src/components/GlobalReduxFilters/searchReducer';
import { clearFilters, triggerGlobalClear } from './components/GlobalReduxFilters/actionCreators'
import {
  setEndDateTime,
  setStartDateTime,
  setLast1Hour,
  setLast6Hours,
  setCustomTime,
  setMonitoringStartDateTime,
  setMonitoringEndDateTime,
  setTopologyStartDateTime,
  setTopologyEndDateTime,
  setMonitoringReloadTime,
  setTopologyReloadTime,
  toggleTopoplogySidePanel,
  closeSubnetwork
} from '../src/components/DateTimeFilter/reducer';
import moment from 'moment';
//import { Toast, ToastBody, ToastContainer, ToastHeader } from "react-bootstrap";
import {
  SystemBar,
  SystemBarComponent,
  AppContainer,
  AppBar,
  AppBody,
  Navigation,
  NavItem,
  NavGroup,
  NotificationTrigger,
  NotificationLogPanel,
  NotificationLogItem,
  useNotification,
  useMultiPageLayout,
  Button
} from '@dsi/react-eds';
import { version } from '../package.json';
import * as localStorage from './lib/localStorage';
import SysPanel from './components/SysPanel';
//import Loader from './components/Loader';
import { nonAdminRoutes, adminRoutes, ROUTEURLS } from './routes';
//const LazyPageNotFound = React.lazy(() => import("./pages/PageNotFound"));
import './App.css';
import useUser from './Context/UserDataContext';
import DateTimeFilter from './components/DateTimeFilter';
import useCustomerData from './Context/CustomerDataContext';
import useCustomers from './hooks/useCustomers';
import { Dialog } from '@cv/eds-react/lib/components/dialog';
import { Tile } from '@cv/eds-react/lib/components/tile';
import useApplicationData from './Context/ApplicationDataContext';
import MITODashboards from './utils/mito-dashboards.json';
import { msalInstance } from './utils/msalInstance';

function randomKey() {
  return Math.random().toString(36).substr(2, 5);
}

function App(props) {
  const { selectedFields, availableFields, actions, selectedRegions } = props;
  const { data, isLoading } = useUser();
  const isAdmin = !!data?.data?.role?.includes('ADMIN_ROLE');
  const routes = isAdmin ? adminRoutes : nonAdminRoutes;
  // const isAdmin = data?.data.role[0] === 'ADMIN_ROLE';
  const location = useLocation();
  const { customer, setCustomer } = useCustomerData();
  const [adminOpen, setAdminOpen] = useState(false);
  const [customerData, setCustomerData] = useState({});
  const [customerModal, setCustomerModal] = useState(false);
  const [noDataModal, setNoDataModal] = useState(false);
  const { data: respDashboardData } = useGetDashboardListData(customer);
  const { data: customerResp } = useCustomers();
  const [dashboardList, setDashboardList] = useState([]);
  const [activeButton, setActiveButton] = useState(null);
  const [mitoDashboardsLinks, setMitoDashboardsLinks] = useState({});
  const [configName, setConfigName] = React.useState('');
  const [sessionExpired, setSessionExpired] = useState(false);
  const dispatch = useDispatch();
  const isInventoryRoute = location.pathname.includes('/inventory');
  const isRackViewRoute = location.pathname.includes('/rackview');
  const handleLogout = () => {
    msalInstance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };
  
  useEffect(() => {
      setMitoDashboardsLinks(MITODashboards);
  }, []);
 // useEffect(() => {
  //   if (data?.data.role.includes('ADMIN_ROLE')) {
  //    setRoutes(adminRoutes)
  //    setIsAdmin(true);
  //    window.localStorage.setItem('isAdmin', 'true');
  //    const flag = window.localStorage.getItem('isAdmin');
  //    setIsAdmin(flag === 'true');
  //   }
  // }, [data?.data]);

  useEffect(() => {
    if (customerResp?.data) {
      setCustomerData(customerResp?.data);
    }
    if (customerResp?.data?.length >= 1) {
      setCustomerModal(true);
    }
    if (customerResp?.data?.length === 1) {
      setCustomer(customerResp?.data[0].id);
      setCustomerModal(false);
    }
    if (!customerResp?.data && customerResp?.data?.length > 1) {
      setCustomerModal(false);
      setNoDataModal(true);
    }
  }, [customerResp]);

  useEffect(() => {
    function getObjectById(array, id) {
      return array?.find((item) => item.id === id) || null;
    }
    const { data: customerData } = customerResp || {};
    const { name: selectedName } = getObjectById(customerData, customer) || {};

    if (customerData?.length === 1) {
      setConfigName(customerData[0]?.name);
    } else {
      setConfigName(selectedName);
    }
  }, [customerResp, customer]);

  const onCustomerChangeRequest = () => {
    setCustomerModal(true);
  };

  const handleBtnClick = (value, e) => {
    setCustomer(value);
    setActiveButton(value);
    setCustomerModal(false);
  };

  const getOptions = () => {
    const result = [];
    let index = 1;
    const options = customerResp && customerResp?.data;
    result.push(
      options?.map((itm, key) => {
        return (
          <button
            className={'customer-btn ' + (activeButton === itm.id ? 'active' : '')}
            key={key}
            index={key}
            onClick={() => handleBtnClick(itm.id)}
          >
            {itm.name}
          </button>
        );
        index++;
      })
    );
    return result;
  };

  const handleCancel = () => {
    setCustomerModal(false);
  };

  const CustomizedFooter = (
    <React.Fragment>
      <Button
        type="text"
        onClick={handleCancel}
        disabled={activeButton ? false : true}
        children="Close"
      />
    </React.Fragment>
  );
  const NoDataFooter = <React.Fragment></React.Fragment>;

  useEffect(() => {
    if (respDashboardData?.data) {
      setDashboardList(respDashboardData?.data);
    }
  }, [respDashboardData]);
  const [currentPath, setCurrentPath] = useMultiPageLayout();
  const { sysPanel, setSysPanel } = useApplicationData();
  const showSysPanel = sysPanel.notifications || sysPanel.userSettings;
  const notificationTimestamps = localStorage.getObject('notifications', {
    new: Date.now(),
    viewed: Date.now()
  });
  const {
    getNotifications,
    getNewNotificationCount,
    addNotifications,
    acknowledgeNotification,
    readNotification
  } = useNotification(
    [
      {
        title: 'React EDS v2.3.0 release',
        description: 'Compatible with EDS v3.11.0',
        timestamp: new Date('2021-10-14 16:00:00')
      },
      {
        title: 'React EDS v2.2.0 release',
        description: 'Pass remaining props as attributes to Dialog div',
        timestamp: new Date('2021-08-10 17:00:00')
      }
    ],
    notificationTimestamps,
    showSysPanel
  );

  const notifications = getNotifications();
  const newNotifications = getNewNotificationCount();
  const toggleSysPanel = (type) => {
    if (type === 'notifications') {
      if (sysPanel.notifications) {
        readNotification();
        localStorage.saveObject('notifications', {
          new: Date.now(),
          viewed: Date.now()
        });
      }
      setSysPanel({
        notifications: !sysPanel.notifications,
        userSettings: false
      });
    } else {
      setSysPanel({
        notifications: false,
        userSettings: !sysPanel.userSettings
      });
    }
  };
  const closeSysPanel = (type) => {
    setSysPanel({
      notifications: false,
      userSettings: false
    });
    if (type === 'notifications') {
      readNotification();
      localStorage.saveObject('notifications', {
        new: Date.now(),
        viewed: Date.now()
      });
    }
  };

  const pathToTitleMap = {
    [ROUTEURLS.inventory]: { title: 'Inventory' },
    [ROUTEURLS.monitoring]: { title: 'Monitoring' },
    [ROUTEURLS.infraMap]: { title: 'Geographical Map' },
    [ROUTEURLS.infraTopology]: { title: 'Infrastructure Topology' },
    [ROUTEURLS.changerequest]: { title: 'Change Requests' },
    [ROUTEURLS.incidents]: { title: 'Incidents' },
    [ROUTEURLS.impactView]: { title: 'Impact View' },
    [ROUTEURLS.vnfView]: { title: 'VNF View' },
    [ROUTEURLS.vmView]: { title: 'VM View' },
    [ROUTEURLS.csuView]: { title: 'CSU View' },
    [ROUTEURLS.nruView]: { title: 'NRU View' },
    [ROUTEURLS.easView]: { title: 'EAS View' },
    [ROUTEURLS.dcgwView]: { title: 'DCGW View' },
    [ROUTEURLS.cmuView]: { title: 'CMU View' },
    [ROUTEURLS.cpaView]: { title: 'CPA View' },
    [ROUTEURLS.ssuView]: { title: 'SSU View' },
    [ROUTEURLS.admindashboards]: { title: 'Admin Dashboards' },
    [ROUTEURLS.visualisations]: { title: 'Visualizations' },
    [ROUTEURLS.dashboardpreview]: { title: 'Dashboard Preview' }
  };

  useEffect(() => {
    notifications
      .filter((item) => item.new)
      .reverse()
      .forEach((item) => {
        const notification = new Notification({
          title: item.title,
          description: item.description,
          timeout: 4000,
          action: () => {
            acknowledgeNotification();
            localStorage.updateObject('notifications', {
              new: Date.now()
            });
          }
        });
        notification.init();
      });
    /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location, setCurrentPath]);

  const adminNavigation = (
    <>
      <NavItem active={currentPath === ROUTEURLS.adminPanel}>
        <Link to={ROUTEURLS.adminPanel}>
          <i className="icon icon-settings"></i>
          User Details
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.admindashboards}>
        <Link to={ROUTEURLS.admindashboards}>
          <i className="icon icon-edit"></i>
          Dashboard Editor
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.visualisations}>
        <Link to={ROUTEURLS.visualisations}>
          <i className="icon icon-edit"></i>
          Visualization Editor
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.jobConfiguration}>
        <Link to={ROUTEURLS.jobConfiguration}>
          <i className="icon icon-settings"></i>
          Job Configuration
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.workspaceconfiguration}>
        <Link to={ROUTEURLS.workspaceconfiguration}>
          <i className="icon icon-settings"></i>
          Workspace Configuration
        </Link>
      </NavItem>
      {/* <NavItem active={currentPath === ROUTEURLS.severityRules}>
        <Link to={ROUTEURLS.severityRules}>
          <i className="icon icon-settings"></i>
          Severity Rules
        </Link>
      </NavItem> */}
    </>
  );
  const mitoDashboardNavigation = (
    <>
    {mitoDashboardsLinks?.dashboards?.length > 0 ? (
      mitoDashboardsLinks.dashboards.map((dashboard, index) => (
        <NavItem key={index}>
          <a href={dashboard.link} target="_blank" rel="noopener noreferrer">
            <i className="icon icon-dashboard"></i>
            {dashboard.name}
          </a>
        </NavItem>
      ))
    ) : (
      <p>No dashboards available.</p>
    )}
  </>
  );
  

  const navigation = (
    <Navigation>
      {/* <NavGroup title="Dashboard" active={currentPath.startsWith('/dashboard')}> */}
      <NavItem active={currentPath === ROUTEURLS.infraMap}>
        <Link to={ROUTEURLS.infraMap}>
          <i className='icon icon-globe'></i>
          Geographical Map
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.monitoring}>
        <Link to={ROUTEURLS.monitoring}>
          <i className="icon icon-graph-circle"></i>
          Monitoring
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.inventory}>
        <Link to={ROUTEURLS.inventory}>
          <i className="icon icon-warehouse"></i>
          Inventory
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.changerequest}>
        <Link to={ROUTEURLS.changerequest}>
          <i className="icon icon-view-list"></i>
          Change Requests
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.incidents}>
        <Link to={ROUTEURLS.incidents}>
          <i className="icon icon-tasks"></i>
          Incidents
        </Link>
      </NavItem>
      <NavItem active={currentPath === ROUTEURLS.infraTopology}>
        <Link to={ROUTEURLS.infraTopology}>
          <i className="icon icon-node-network"></i>
          Topology View
        </Link>
      </NavItem>
      {/*<NavItem active={currentPath === ROUTEURLS.rackview}>
        <Link to={ROUTEURLS.rackview}>
          <i className="icon icon-warehouse"></i>
          Rack View
        </Link>
      </NavItem>*/}
       {/*<NavItem active={currentPath === ROUTEURLS.performancemanagement}>
        <Link to={ROUTEURLS.performancemanagement}>
          <i className="icon icon-warehouse"></i>
          Performance Management
        </Link>
      </NavItem>*/}
      <NavGroup
        key="cd"
        title="Dashboards"
        active={currentPath.startsWith('/dashboard-preview')}
      >
        {dashboardList &&
          dashboardList.map((d, i) => (
            <NavItem key={i} active={currentPath === `/dashboard-preview/${d.id}`}>
              <Link to={`/dashboard-preview/${d.id}`} state={d.id}>
                <i className="icon icon-dashboard"></i>
                {d.name}
              </Link>
            </NavItem>
          ))}
      </NavGroup>
        {isAdmin && (
        <NavGroup
          key="ab"
          title={
            <div
              onClick={() => setAdminOpen((prev) => !prev)}
              style={{ display: 'block', cursor: 'pointer', marginTop: '-21px' }}
            >
              <span className='admin-side-bar-btn'>Admin Panel</span>
            </div>
          }
          active={adminOpen}
        >
          {adminNavigation}
        </NavGroup>
      )}
      <NavItem>
        <a href="https://storage.cloud.google.com/bharti-bmas-in-spg-prod/eai-spg-correlated-report/Bharti_HCloud_Compute_Topology_Report.csv" target='_blank'><i className='icon icon-download-save'></i>EAI Corelated Report</a>
      </NavItem>
      <NavGroup key="dm" title="MITO Dashboard Links">
        {mitoDashboardNavigation}
      </NavGroup>

      {/* <NavItem active={currentPath === ROUTEURLS.jsonchemeaform}>
        <Link to={ROUTEURLS.jsonchemeaform}>
          <Button iconOnly icon="node-network" />
          Schema Inputs
        </Link>
      </NavItem> */}
      {/* </NavGroup> */}

      {/* <NavGroup title="View" active={currentPath.startsWith('/view')}> */}
      {/* <NavItem active={currentPath === ROUTEURLS.infraMap}>
          <Link to={ROUTEURLS.infraMap}>Map</Link>
        </NavItem>
        <NavItem active={currentPath === ROUTEURLS.infraTopology}>
          <Link to={ROUTEURLS.infraTopology}>Topology</Link>
        </NavItem>
        <NavItem active={currentPath === ROUTEURLS.impactView}>
          <Link to={ROUTEURLS.impactView}>Impact</Link>
        </NavItem>
        <NavItem active={currentPath === ROUTEURLS.vnfView}>
          <Link to={ROUTEURLS.vnfView}>VNF View</Link>
        </NavItem>
        <NavItem active={currentPath === ROUTEURLS.vmView}>
          <Link to={ROUTEURLS.vmView}>VM View</Link>
        </NavItem>
        <NavGroup title="Shell" active={currentPath.startsWith('/view/shell')}>
          <NavItem active={currentPath === ROUTEURLS.csuView}>
            <Link to={ROUTEURLS.csuView}>CSU View</Link>
          </NavItem>
          <NavItem active={currentPath === ROUTEURLS.nruView}>
            <Link to={ROUTEURLS.nruView}>NRU View</Link>
          </NavItem>
          <NavItem active={currentPath === ROUTEURLS.easView}>
            <Link to={ROUTEURLS.easView}>EAS View</Link>
          </NavItem>
          <NavItem active={currentPath === ROUTEURLS.dcgwView}>
            <Link to={ROUTEURLS.dcgwView}>DCGW View</Link>
          </NavItem>
          <NavItem active={currentPath === ROUTEURLS.cmuView}>
            <Link to={ROUTEURLS.cmuView}>CMU View</Link>
          </NavItem>
          <NavItem active={currentPath === ROUTEURLS.cpaView}>
            <Link to={ROUTEURLS.cpaView}>CPA View</Link>
          </NavItem>
          <NavItem active={currentPath === ROUTEURLS.ssuView}>
            <Link to={ROUTEURLS.ssuView}>SSU View</Link>
          </NavItem>
        </NavGroup> */}
      {/* </NavGroup> */}
    </Navigation>
  );
  const pageTitle =
    (pathToTitleMap[currentPath] && pathToTitleMap[currentPath].title) || '';
  const pageSubtitle =
    pathToTitleMap[currentPath] && pathToTitleMap[currentPath].subtitle;
  
    const handleClearFilters = () => {
      dispatch(resetFilters()); // this is for global filter clear.
      dispatch(clearFilters()); // this is for sub filter clear.
      dispatch(setSearchText(''));
      dispatch(triggerGlobalClear());
      const current = window.location.hash;
      const path = current.split('?')[0]; 
      window.location.hash = path;
      const now = moment();
      const oneHourAgo = moment().subtract(1, 'hour');

      dispatch(setStartDateTime(oneHourAgo));
      dispatch(setEndDateTime(now));
      dispatch(setTopologyStartDateTime(oneHourAgo));
      dispatch(setTopologyEndDateTime(now));
      dispatch(setMonitoringStartDateTime(oneHourAgo));
      dispatch(setMonitoringEndDateTime(now));
      dispatch(setLast1Hour());
      if (selectedRegions?.length > 0) {
        dispatch(toggleTopoplogySidePanel(false))
        dispatch(closeSubnetwork(false))
      }
      
    };
    
  return (
    <>
      <SystemBar product="SPG" acronym="SPG Application" homeLink="#/monitoring">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="customer-name wid-13">
            <span title="Change Customer">{configName}</span>
            <span className="mb-1 change-workspace-btn ms-2">
              <i
                onClick={() => onCustomerChangeRequest()}
                title="Change Workspace"
                className="icon icon-reload"
              ></i>
            </span>
          </div>
          <div className="d-flex justify-content-end align-items-center w-100">
            <SystemBarComponent noHover={true}>
              {/* <a href="https://gitlab.seld.rnd.ericsson.se/EKRISVA/react-eds/blob/master/CHANGELOG.md" rel="noopener noreferrer" target="_blank">{`v${version}`}</a> */}
              <div style={{ display: 'flex', gap: '20px' }}>
                <Globalfilters />
                {!isInventoryRoute && !isRackViewRoute && <DateTimeFilter />}
                <Button onClick={handleClearFilters}>Clear</Button>
              </div>
            </SystemBarComponent>
            
            {/* <NotificationTrigger
              notifications={newNotifications}
              onClick={() => {
                toggleSysPanel('notifications');
                acknowledgeNotification();
                localStorage.updateObject('notifications', {
                  new: Date.now()
                });
              }}
            /> */}
            <SystemBarComponent onClick={() => toggleSysPanel('userSettings')}>
              <i className="icon icon-profile" />
              <span className="user" style={{marginRight: '10px'}}>{data ? data.data.userName : 'Username'}</span>
            </SystemBarComponent>
            <Button onClick={handleLogout}>Logout</Button>
          </div>
        </div>
      </SystemBar>

      <AppContainer
        showSystemPanel={showSysPanel}
        systemPanels={[
          <SysPanel
            key="userPanel"
            hidden={!sysPanel.userSettings}
            onClose={() => closeSysPanel('userSettings')}
          />,
          <NotificationLogPanel
            key="notificationPanel"
            hidden={!sysPanel.notifications}
            onClose={() => {
              closeSysPanel('notifications');
              readNotification();
              localStorage.saveObject('notifications', {
                new: Date.now(),
                viewed: Date.now()
              });
            }}
          >
            {/* {/* {notifications.map((item) => (
              <NotificationLogItem
                key={randomKey()}
                isNew={item.viewed}
                title={item.title}
                description={item.description}
                timestamp={item.timestamp}
              />
            ))} */}
            {/* <FieldsSelector
              available={availableFields}
              selected={selectedFields}
              onSelect={actions.selectField}
              onUnselect={actions.unselectField}
            />

            <FilterList  /> */}
          </NotificationLogPanel>
        ]}
      >
        <AppBar
          subtitle={pageSubtitle}
          // actionsRight={<DateTimeFilter />}
        >
          {/* {pageTitle} */}
          {routes.map(({ path, Component }, key) => (
            <Route
              exact
              path={path}
              key={key}
              render={(props) => {
                return (
                  <>
                    <BreadCrumbs />
                  </>
                );
              }}
            />
          ))}
        </AppBar>
        <AppBody navigation={navigation}>
          <Suspense >
            <Switch>
              {routes.map(({ name, path, Component }, key) => (
                <Route
                  exact={true}
                  path={path}
                  key={key}
                  render={(props) => {
                    //console.log(`Generated crumbs for ${props.match.path}`);
                    //crumbs.map(({ name, path }) => console.log({ name, path }));
                    return (
                      <>
                        {/* <BreadCrumbs /> */}
                        <Component {...props} />
                      </>
                    );
                  }}
                />
              ))}
              {/* <Route component={MissingPage} /> */}
            </Switch>
          </Suspense>
        </AppBody>
      </AppContainer>

      <Dialog
        open={customerModal}
        footer={CustomizedFooter}
        title="Select Customer"
        onCancel={handleCancel}
        className="customer-popup"
      >
        <Tile className="cust-form-group px-1 py-0" title="">
          {getOptions()}
        </Tile>
      </Dialog>
      <Dialog open={noDataModal} footer={NoDataFooter} title="Warning">
        <Tile className="cust-form-group px-1" title="">
          <p>You don't have access to any regions. Contact your administrator.</p>
        </Tile>
      </Dialog>
      {sessionExpired && (
     <Dialog
        open={sessionExpired}
        onClose={() => {}}
        title="Session Expired"
        footer={
          <Button onClick={handleLogout}>OK</Button>
        }
      >
    <Tile> Your session has expired. You will be redirected to the login page. </Tile>
  </Dialog>
)}
      {/*isError && (
        <ToastContainer
          className="p-3"
          style={{ zIndex: "400" }}
          position="top-end"
        >
          <Toast autohide delay={3000}>
            <ToastHeader closeButton={false}>
              <strong className="me-auto color-red">Error</strong>
            </ToastHeader>
            <ToastBody>
              {error ? error.message : "Something went wrong!!!"}
            </ToastBody>
          </Toast>
        </ToastContainer>
      )*/}
    </>
  );
}

function mapStateToProps(state) {
  return {
    selectedFields: state.globalFilterReducer.get('selectedFields'),
    availableFields: state.globalFilterReducer.get('availableFields'),
    selectedRegions: state.regionReducer.selectedRegions
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actionCreators, dispatch) };
}

//export default connect(mapStateToProps, mapDispatchToProps)(App);
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(App));
